import { createFileRoute } from '@tanstack/react-router'

import { OrganisationScreen } from '@/features/org-settings/organisation-screen'

export const Route = createFileRoute('/_app/_org/settings/organisation')({
  component: OrganisationScreen,
})
